import React from "react";
//#region types
import { PeriodToggleProps, TimeReportPeriod } from "models/propTypes/timeReportingPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ToggleButtonGroup } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const week: TimeReportPeriod = "week";
const month: TimeReportPeriod = "month";

const PeriodToggle: React.FC<PeriodToggleProps> = (props) => {
  const { period, onShowWeek, onShowMonth } = props;

  return (
    <Grid item className={cssExports.periodToggle}>
      {/* Controlled, so the toggle keeps showing the current view while an unsaved-changes prompt is open or
          after it is dismissed. */}
      <ToggleButtonGroup
        colorVariation="dark"
        selectionKey={period}
        buttons={[
          {
            buttonKey: week,
            children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.WeekPascal),
            onClick: period === week ? undefined : onShowWeek,
            testId: "showWeekButton",
          },
          {
            buttonKey: month,
            children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.MonthPascal),
            onClick: period === month ? undefined : onShowMonth,
            testId: "showMonthButton",
          },
        ]}
      />
    </Grid>
  );
};

export default PeriodToggle;
